var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGuide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  d: "M14.953 1s1.344 6.804 4.294 9.73C22.187 13.656 29 14.953 29 14.953s-6.804 1.344-9.73 4.294C16.344 22.187 15.047 29 15.047 29s-1.344-6.804-4.294-9.73C7.813 16.344 1 15.047 1 15.047s6.804-1.344 9.73-4.294C13.656 7.813 14.953 1 14.953 1z"
})));
export default SvgIconGuide;